import { memo } from "react";
import { Markdown } from "./Markdown";
import { UnifiedMessage } from "@/hooks/use-messages";

type TextMessageProps = {
  message: UnifiedMessage;
};

export const TextMessage = memo(
  function TextMessage({ message }: TextMessageProps) {
    const content = message.text || message.message || "";
    return (
      <div
        className={`w-full mb-4 flex items-start ${message.isUser || message.isSelf ? "justify-end" : "justify-start"}`}
      >
        <p
          className={`inline-block pt-3 pr-3 pb-3 pl-[23px] ${
            message.isUser || message.isSelf
              ? "bg-[#191919] text-white rounded-tl-[50px] rounded-tr-[20px] rounded-bl-[50px]"
              : "bg-gray-200 text-gray-800 text-left rounded-tl-[20px] rounded-tr-[50px] rounded-br-[50px]"
          } [@media(max-width:440px)]:text-[13px] leading-[100%]`}
        >
          {message.isMarkdown ? <Markdown>{content}</Markdown> : content}
        </p>
      </div>
    );
  },
  (prevProps, nextProps) => {
    // Only re-render if the message text has changed
    return (
      prevProps.message.text === nextProps.message.text &&
      prevProps.message.message === nextProps.message.message
    );
  },
);
